export default {
  getUsers: (state) => state.users,
  getUser: (state) => state.user,
  getPartners: (state) => state.partners,
  getStores: (state) => state.stores,
  getAreps: (state) => state.areps,
};
